// src/hooks/useGoogleSignUp.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

type GoogleSignUpPayload = {
  credential: string;
};

export const useGoogleSignUp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: GoogleSignUpPayload) => {
      const { data } = await axios.post('/api/auth/google-signup', payload);
      return data;
    },
    onSuccess: (user) => {
      // e.g. refetch the current user or any other relevant queries
      // queryClient.invalidateQueries({ queryKey: ['me'] });
      queryClient.setQueriesData({ queryKey: ['me'] }, () => ({
        ...user,
      }));
    },
    onError: (error: any) => {
      // you can log or transform the error here if you like
      console.error('Google signup failed', error);
    },
  });
};
